export enum EInvoiceIneligibilityReason {
  ClientNotCompany = 'clientNotCompany',
  ClientNotFrench = 'clientNotFrench',
  ClientNotPrivate = 'clientNotPrivate',
}
